import {Component} from "react";
import React from "react";

import Content from "../../organisms/Content";
import Carousel from '../../organisms/Carousel';
import '../../../images/icons.css';
import ProjectHero from "../../organisms/ProjectHero";
import TextBlock from "../../molecules/TextBlock";
import ProjectDescription from "../../organisms/ProjectDescription";
import DoubleTextBlock from "../../molecules/DoubleTextBlock";
import ProjectInformation from "../../molecules/ProjectInformation";
import ColoredBackground from "../../atoms/ColoredBackground";

import VideoCover from 'react-video-cover';
import VideoBox from "../../molecules/VideoBox";
import VisibilityFader from "../../atoms/VisibilityFader";


class AboundProject extends Component {


    render(){



        let slide_1 = {
            width:"1200",
            height:"640",
            url:'/images/abound/abound_screenshot_01.jpg',
            isVideo: false,
        };

        let slide_2 = {
            width:"1200",
            height:"640",
            url:'/images/abound/abound_screenshot_02.jpg',
            isVideo: false,
        };

        let slide_3 = {
            width:"1200",
            height:"640",
            url:'/images/abound/abound_screenshot_03.jpg',
            isVideo: false,
        };

        let slide_4 = {
            width:"1200",
            height:"640",
            url:'/images/abound/abound_screenshot_04.jpg',
            isVideo: false,
        };

        let slide_5 = {
            width:"1200",
            height:"640",
            url:'/images/abound/abound_screenshot_05.jpg',
            isVideo: false,
        };

        // process
        let processSlide_1 = {
            width:"1200",
            height:"500",
            url:'/images/abound/abound_process_01.jpg',
            isVideo: false,
        };

        let processSlide_2 = {
            width:"1200",
            height:"500",
            url:'/images/abound/abound_process_07.jpg',
            isVideo: false,
        };

        let processSlide_3 = {
            width:"1200",
            height:"500",
            url:'/images/abound/abound_process_03.jpg',
            isVideo: false,
        };

        let processSlide_4 = {
            width:"1200",
            height:"500",
            url:'/images/abound/abound_process_04.jpg',
            isVideo: false,
        };

        let processSlide_5 = {
            width:"1200",
            height:"500",
            url:'/images/abound/abound_process_05.jpg',
            isVideo: false,
        };

        let processSlide_6 = {
            width:"1200",
            height:"500",
            url:'/images/abound/abound_process_02.jpg',
            isVideo: false,
        };

        let processSlide_7 = {
            width:"1200",
            height:"500",
            url:'/images/abound/abound_process_06.jpg',

            isVideo: false,
        };


        return (
            <div>
                <ProjectHero imgUrl={'/images/abound/abound_hero.jpg'}
                             imgUrlMobile={'/images/abound/abound_hero_mobile_2.jpg'}
                             noWave={true}
                             title={"ABOUND"}
                             subTitle={"Swarm Behaviour Game"}
                             isLight={false}
                             pictureAlignBottom={true}/>

                <ProjectDescription darkText>
                    In ABOUND you take control over a swarm. Collect smaller swarms, avoid the attacks of bigger swarms, or just enjoy the
                    patterns and sounds that you can create by exploring the abstract world.
                </ProjectDescription>

                <Content>

                    <VisibilityFader>
                        <ProjectInformation
                            blocks={[
                                {
                                    caption: "time",
                                    text:
                                        <span>
                                            2018<br/>
                                            3 months
                                        </span>
                                },
                                {
                                    caption: "tasks",
                                    text:
                                        <span>
                                            Lead Development<br/>
                                            Game Design<br/>
                                            System Design<br/>
                                            Source Control
                                        </span>
                                },
                                {
                                    caption: "context",
                                    text:
                                        <span>
                                            3rd semester project<br/>
                                            Game Design (BA)<br/>
                                            HTW Berlin
                                        </span>
                                },
                                {
                                    caption: "team",
                                    text:
                                        <span>
                                            Malte Decker<br/>
                                            Julian Hellmann<br/>
                                            Barbara Langa<br/>
                                            Florian Wolf
                                        </span>
                                },
                            ]}
                        />
                    </VisibilityFader>

                    <VisibilityFader>
                        <VideoBox url={'https://www.dl.dropboxusercontent.com/s/zrmebl9howcjf0b/abound_gameplay_edited.mp4'}/>
                    </VisibilityFader>

                    <VisibilityFader>
                        <TextBlock
                                blockText={true}
                                hasTopPadding={false}
                                halfPadding={false}
                                caption={<span>game<br/>play</span>}
                                captionMobile={<span>gameplay</span>}
                                sideCaption={false}
                        >
                                You start out as a very small swarm. Around you are many other swarms, some bigger, some smaller than you.
                                If you touch a smaller swarm, its entities, called Boids, get converted into your swarm.
                                Other bigger swarms chase you upon sight and try to steal Boids from you.
                                The bigger you are, the faster you can fly, but the less precise you can maneuver.
                                The game is won when all swarms are collected.
                        </TextBlock>
                    </VisibilityFader>

                    <VisibilityFader>
                        <Carousel slides={[slide_1, slide_2, slide_3, slide_4, slide_5]} />
                    </VisibilityFader>

                    <ColoredBackground color={"#202020"}>
                        <VisibilityFader>
                            <TextBlock
                                    blockText={true}
                                    hasTopPadding={false}
                                    halfPadding={true}
                                    caption={<span>flock<br/>ing</span>}
                                    captionMobile={<span>flocking algorithms</span>}
                                    sideCaption={false}
                            >
                                    Even though it feels as if you control the whole swarm, what you actually control is an
                                    invisible goal point next to the tip. Each individual Boid tries to follow
                                    that goal. At the same time it tries to avoid obstacles and compares itself to its closest
                                    neighbours. Boids always try to keep a distance to their neighbours and roughly fly into the
                                    same direction. These algorithms closely follow the bird and fish flocking rules observable in
                                    nature. The ratio of these flocking parameters changes based on game events, player input and swarm sizes, resulting in different swarm shapes.
                            </TextBlock>
                        </VisibilityFader>

                        <VisibilityFader>
                            <TextBlock
                                    blockText={true}
                                    hasTopPadding={false}
                                    caption={<span>tech</span>}
                                    captionMobile={<span>implementation</span>}
                                    sideCaption={false}
                            >
                                    All flocking calculates are outsourced to the GPU via HLSL compute shader,
                                    while the input logic and parameter generation is handled on the CPU and then fed to the GPU in small intervals.
                                    In between these intervals each Boid interpolates to
                                    its last received position. Handling all flocking calculations on the CPU would
                                    not have been possible due to the exponential complexity of flocking algorithms. Neither could
                                    all calculations be done on the GPU, since game logic and player input constantly influence the parameters needed on the GPU.
                                    Utilizing this interval based hybrid approach, over 4000 interactive and obstacle avoiding Boids can be simulated at once at 60 fps, accessing the GPU every 0.1 seconds.
                            </TextBlock>
                        </VisibilityFader>

                        <VisibilityFader>
                            <Carousel slides={[ processSlide_2, processSlide_3, processSlide_4, processSlide_5, processSlide_6, processSlide_1]}/>
                        </VisibilityFader>

                    </ColoredBackground>


                    <ColoredBackground color={"#fcfcfc"}>
                        <VisibilityFader>
                            <DoubleTextBlock
                                blockText={true}
                                darkText={true}
                                centeredText={false}
                                captionLeft={<span>process</span>}
                                textLeft={
                                    <span>
                                        Very early into the ideation phase we settled on making a game that utilizes swarm movements as
                                        its core mechanic. Crafting a working concept out of that proved to be very difficult,
                                        since all ideas surrounding the topic took a lot of time to implement,
                                        which basically made it impossible to quickly prototype and test our ideas.
                                        After the architecture for simulating flocking behaviour was up, we were able to
                                        tweak the dynamics of the game. Around the core goal to get bigger we introduced enemy swarms,
                                        which turned the task into a risky dance.
                                    </span>
                                }
                                captionRight={<span>learnings</span>}
                                textRight={
                                    <span>
                                        I always wanted to work with swarm algorithms. The underlying flocking rules
                                        turned out to be quite difficult to implement in a modular and lightweight way.

                                        The project taught me a lot about HLSL compute shaders, performance optimization and
                                        dynamic data handling. Due to the height of that first technology barrier, the
                                        ideation phase was a challenge on its own, without any clear knowledge whether the
                                        outcome will be fun and/or functional. While it was quite a ride in that sense, I enjoyed it a lot!

                                    </span>
                                }
                            />
                        </VisibilityFader>


                    </ColoredBackground>
                </Content>
            </div>
        );
    }
}

export default AboundProject;